/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeAutoObservable, runInAction } from "mobx";
import { Category } from "../types/product";
import http from "../libs/http";
import _ from "lodash";
import { AuthResponse, City, User } from "../types/common";

class AppStore {
  private categoriesRequestId = 0;

  categories: Category[] = JSON.parse(
    localStorage.getItem("categories") ?? "[]"
  );

  categoryMap: Map<string, Category> = new Map<string, Category>();

  selectedCity: string = localStorage.getItem("city") || "";

  cities: City[] = JSON.parse(localStorage.getItem("cities") || "[]");

  user?: User = JSON.parse(localStorage.getItem("user") || "{}");

  closedAuthModal = !!localStorage.getItem("access_token");

  dateSync?: string;

  // Добавляем observable поле для отслеживания состояния
  private _authToken: string | null = localStorage.getItem("access_token");

  // Cookie consent status
  cookieConsentAccepted: boolean = localStorage.getItem("cookieConsent") === "true";

  get isLoginIn() {
    return !!this._authToken;
  }

  constructor() {
    makeAutoObservable(this);
  }

  getCategories = async () => {
    const requestId = ++this.categoriesRequestId;
    const { data } = await http.get<Category[]>("api/categories");

    if (requestId === this.categoriesRequestId) {
      runInAction(() => {
        this.categories = data;
        localStorage.setItem("categories", JSON.stringify(this.categories));
      });
    }

    return data;
  };

  buildCategoryMap = (categories: Category[]) => {
    categories.forEach((category) => {
      this.categoryMap.set(category.ref_key, category);
      if (category.children) {
        this.buildCategoryMap(category.children);
      }
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCategoryByKey = (
    categories: Category[],
    refKey: string
  ): Category | any => {
    return _.find(categories, (category) => {
      return (
        category.ref_key === refKey ||
        this.getCategoryByKey(category.children, refKey)
      );
    });
  };

  findCategoryPath(
    categories: Category[],
    targetRefKey: string,
    currentPath: Category[] = []
  ): Category[] | null {
    for (const category of categories) {
      const newPath = [...currentPath, category];

      // Если нашли целевую категорию
      if (category.ref_key === targetRefKey) {
        return newPath;
      }

      // Ищем в дочерних категориях
      if (category.children && category.children.length > 0) {
        const foundPath = this.findCategoryPath(
          category.children,
          targetRefKey,
          newPath
        );
        if (foundPath) {
          return foundPath;
        }
      }
    }

    return null;
  }

  async getCities() {
    const { data } = await http.get("api/cities");

    runInAction(() => {
      this.cities = data;
    });
    localStorage.setItem("cities", JSON.stringify(this.cities));
  }

  setCity(city: string) {
    runInAction(() => {
      this.selectedCity = city;
    });
    localStorage.setItem("city", city);
  }

  setClosedAuthModal(value: boolean) {
    console.log(value);

    runInAction(() => {
      this.closedAuthModal = value;
    });
  }

  onAuthCompleted(data: AuthResponse) {
    localStorage.setItem("access_token", data.access_token);

    this._authToken = data.access_token;

    localStorage.setItem("user", JSON.stringify(data.user));
  }

  get userInfo(): User {
    return JSON.parse(localStorage.getItem("user") || "{}");
  }

  async getUser() {
    const { data } = await http.get("api/user");

    if (data) {
      this.user = data;

      localStorage.setItem("user", JSON.stringify(data));
    }
  }

  async logout() {
    const { data } = await http.post("api/auth/logout");
    if (data) {
      this.user = undefined;
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
      window.location.pathname = "/";
    }
  }

  async getSyncDate() {
    const { data } = await http.get("api/misc/nomenclature-sync-date");

    runInAction(() => {
      this.dateSync = data.date;
    });
  }

  acceptCookieConsent() {
    runInAction(() => {
      this.cookieConsentAccepted = true;
    });
    localStorage.setItem("cookieConsent", "true");
  }
}

export default new AppStore();
